"use client"; // Next.js 15에서 클라이언트 컴포넌트임을 명시

import { ArrowBack, ArrowBackIos, ArrowBackIosNew, ArrowBackIosNewOutlined } from "@mui/icons-material";
import { IconButton, SxProps } from "@mui/material";
import { useD3Navigation } from "../provider/NavigationProvider";
import { Theme } from "@emotion/react";

export default function BackButton({ sx }: { sx?: SxProps<Theme> }) {
  const { goBackOrHome } = useD3Navigation();
  return (
    <IconButton
      aria-label="previous"
      onClick={goBackOrHome}
      sx={{
        ...(sx || {}), // ← 스프레드
      }}
    >
      <ArrowBackIosNew />
    </IconButton>
  );
}
